import React from "react";

import {
  Layout,
  SEO,
  BannerStandard,
  ContentServiceTargetAudience,
  ContentServiceDescription,
  ContentServiceSignUp,
  ContainerBackgroundWhite,
} from "../../components";

import { ServicesData } from "../../components/data";
import { Colors } from "../../components/constants";
import { ListCheckMarks } from "../../components/lists";
import { InternalLinkTypes } from "../../components/links";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { Testimonials } from "../../components/testimonials";

const Pdbidr = () => {
  const service = ServicesData["pdbidr"];
  const data = useStaticQuery(graphql`
    query {
      ImgVadvisorLeft: file(
        relativePath: { eq: "services/vadvisor/vadvisor_left.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      Img2: file(
        relativePath: { eq: "services/vadvisor/pdbidr_workflow.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ImgVadvisorFront: file(
        relativePath: { eq: "services/vadvisor/vadvisor_front.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  const ImgVadvisorLeft = ({ style }) => {
    return (
      <Img fluid={data.ImgVadvisorLeft.childImageSharp.fluid} style={style} />
    );
  };
  const ImgVadvisorFront = ({ style }) => {
    return (
      <Img fluid={data.ImgVadvisorFront.childImageSharp.fluid} style={style} />
    );
  };
  //
  // const Img1 = ({ style }) => {
  //   return <Img fluid={data.Img1.childImageSharp.fluid} style={style} />;
  // };
  //
  // const Img2 = ({ style }) => {
  //   return <Img fluid={data.Img2.childImageSharp.fluid} style={style} />;
  // };

  return (
    <Layout pageLink={InternalLinkTypes.ServicesVadvisor}>
      <SEO
        title={service.title}
        description={
          "Our pdBidr platform encompasses a set of forecasting algorithms, an optimisation engine and bid submission for scheduled and semi-scheduled generators and energy storage systems"
        }
      />
      <BannerStandard title={service.title} subTitle={service.description} />
      <ContentServiceDescription
        image={<ImgVadvisorLeft />}
        description={
          <div>
            <h2
              style={{
                color: Colors.DARK_BLUE,
                fontWeight: "bold",
                fontSize: "1.17rem",
              }}
            >
              Imagine continuously optimising your assets by automating the
              management of your load, renewable plant, generator or ESS.
            </h2>
            <h3
              style={{
                color: Colors.LIGHT_BLUE,
                fontSize: "1rem",
                fontWeight: "500",
              }}
            >
              Our pdBidr platform encompasses a set of forecasting algorithms,
              an optimisation engine, algorithmic priceband volume allocation and bid submission for scheduled and
              semi-scheduled plant and energy storage systems.
            </h3>
            <ListCheckMarks
              items={[
                "Maximise your battery, plant or portfolio value",
                "Energy and FCAS co-optimised",
                "For larger portfolios why not automate FCAS bids?",
                "Continuous bid reformulation and automated submission",
                "Second algorithmic layer for priceband volume allocation",
                "Performance benchmarking - quantify value - learn and improve",
                "Integrate with sophisticated trading teams or operate autonomously",
                "Multiple algorithmic layers – price and FCAS utilisation forecasting, and optimisation engine",
              ]}
            />
           
          </div>
        }
      />
      <ContentServiceTargetAudience
        // freeTrialLink={service.freeTrialLink}
        targetAudienceList={service.targetAudienceList}
      />
      {/*<ContentServiceModule*/}
      {/*  descriptionList={null}*/}
      {/*  title={"pdBidr workflow for bidding scheduled plant including batteries and renewables"}*/}
      {/*  image={<Img2 />}*/}
      {/*  isBackgroundWhite={false}*/}
      {/*  isImageRightAligned={true}*/}
      {/*/>*/}
      <div
        style={{
          textAlign: "center",
          padding: "2rem 10%",
          background: Colors.LIGHTER_BLUE,
        }}
      >
        <Testimonials showFindMoreLink={false} />
      </div>
      <ContentServiceSignUp
        title={service.title}
       
        videoLink={service.watchVideoLink}
      />
      <ContainerBackgroundWhite style={{ padding: "1% 20%" }}>
        <ImgVadvisorFront />
      </ContainerBackgroundWhite>
    </Layout>
  );
};

export default Pdbidr;
